import React from 'react'

import './styles.css'

const BorderButton = ({ label, disabled, className, leftIcon, onClick }) => (
    <button className={`border-button ${className}`} onClick={onClick} disabled={disabled}>
        {leftIcon}
        {label}
    </button>
)

export default BorderButton
